module.exports = __webpack_public_path__ + "img/member-info-missing.f977412e.svg";